import { render, staticRenderFns } from "./BillsItems.vue?vue&type=template&id=8ba4ca7e&"
import script from "./BillsItems.vue?vue&type=script&lang=js&"
export * from "./BillsItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports